<script lang="ts">
	import { page } from '$app/stores';
	import { PUBLIC_FRONTEND_URL } from '$env/static/public';

	let alternateLinks: any[] = [];
	let cannonicalLink: string = '';

	$: currentSlug = $page.url.pathname.split('/').splice(2).join('/');

	function calculateLinks(slug: string) {
		if (slug === '' || slug == 'en') {
			slug = 'home';
		}

		let aLinks = [];

		for (const p of $page.data.pageList) {
			if (p[$page.params?.lang] === slug) {
				for (const l of $page.data.languages) {
					const pSlug = p[l.code] === 'home' ? '' : p[l.code];
					aLinks.push({
						url: PUBLIC_FRONTEND_URL + '/' + l.code + '/' + pSlug,
						lang: l.code
					});
				}

				const cSlug = p['en'] === 'home' ? '' : p['en'];
				cannonicalLink = PUBLIC_FRONTEND_URL + '/en/' + cSlug;
				break;
			}
		}

		alternateLinks = aLinks;
	}

	$: calculateLinks(currentSlug);
</script>

{#each alternateLinks as link}
	{#key link.url}
		<link rel="alternate" href={link.url} hreflang={link.lang} />
	{/key}
{/each}
<link rel="canonical" href={cannonicalLink} />
